import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Components from 'components';
import Plugins from 'plugins';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function($) {
    Components.init();
    Plugins.init();
});